/**
 * Browser-side API Client
 *
 * Use this in Client Components ('use client').
 * Calls API directly with cross-subdomain cookies (credentials: 'include').
 *
 * @example
 * ```tsx
 * 'use client';
 * import { BrowserApiClient } from '@website/lib/api/browser';
 *
 * const data = await BrowserApiClient.getActivities({ limit: 10 });
 * ```
 */
import { createApiClient } from '@api';

import { browserFetch } from './browserFetch';

/**
 * API client for browser-side requests.
 *
 * Calls API directly with cross-subdomain httpOnly cookies.
 * Use this in Client Components and client-side hooks.
 */
export const BrowserApiClient = createApiClient(browserFetch);

// Unified export for conditional imports - bundler picks server.ts or browser.ts
export const ApiClient = BrowserApiClient;

// Re-export the fetch implementation and error class for advanced use cases
export { browserFetch, ApiError } from './browserFetch';

// Re-export types
export type { ApiClient as ApiClientType, CustomFetchFn, CustomFetchOptions } from '@api';
